import React from "react";
import { useIsDark } from "@/context/ThemeContext";
import { twMerge } from "tailwind-merge";

const BusinessCard = ({ icon, title, className = "", onClick, imageStyles, contentStyles, textStyles, hideText = false, ...props }) => {
  const isdark = useIsDark();
  
  return (
    <div
      className={twMerge(
        `
        relative 
        group 
        backdrop-blur-sm 
        rounded-lg
        p-4
        cursor-pointer 
        transition-all 
        duration-300 
        overflow-hidden
        inline-flex
        h-[70px] sm:h-[70px] md:h-[80px]
        ${isdark ? "bg-[#161616]" : "bg-[#FFFFFF]"}
        `,
        className
      )}
      onClick={onClick}
      {...props}
    >
      {/* Gradient Border*/}
      <div
        className="
          absolute 
          inset-0 
          rounded-lg 
          opacity-0 
          group-hover:opacity-100 
          transition-opacity 
          duration-300
          pointer-events-none
        "
        style={{
          background: `linear-gradient(99.8deg, #FF1CF7 4.16%, ${
            isdark ? "#161616" : "#FFFFFF"
          } 33.14%)`,
          padding: "1px",
        }}
      >
        <div
          className={`w-full h-full rounded-lg ${
            isdark ? "bg-[#161616]" : "bg-[#FFFFFF]"
          }`}
        />
      </div>

      {/* Content */}
      <div
        className={twMerge(
          "relative z-10 flex items-center gap-4",
          contentStyles
        )}
      >
        <div className="relative group-hover:scale-110 transition-transform duration-300">
          <img
            src={icon}
            alt={title}
            className={twMerge(
              "object-contain sm:w-[32px] sm:h-[32px] md:w-[38px] md:h-[38px]",
              imageStyles
            )}
          />
        </div>

        <span
          className={twMerge(
            "font-alexandria font-normal text-[16px] sm:text-[16px] md:text-[16px] lg:text-[16px] xl:text-[18px] laptop:text-[18px] 3xl:text-[22px] sm:leading-[150%] leading-[120%] tracking-[0%] uppercase",
            textStyles,
            hideText ? "hidden small:block" : ""
          )}
          style={{ color: isdark ? "#B6B6B6" : "#575757" }}
        >
          {title}
        </span>
      </div>
    </div>
  );
};

export default BusinessCard;
